import React from "react";
const WhyUsSection = ()=>{
    return(
        <section className="WhyUsSection">
            <div className="OverlayFooter"></div>
            <div className="container CustomContainer">
                <div className="row">
                    <div className="col-lg-6 col-md-6 WhyUsCol WhyChooseSpan">
                        
                        Why
                        <br />
                        choose us.!
                        

                    </div>
                    <div className="col-lg-6 col-md-6 WhyUsCol WhyChooseUsText">
                        
                        At MIND, we combine expertise with a customer-centric approach to deliver top-quality services tailored to your needs. Our proven track record and commitment to excellence ensure that you receive the best solutions every time. Choose us for our dedication, reliability, and exceptional results.
                        
                    </div>
                </div>
            </div>
        </section>
    );
}
export default WhyUsSection;